<template>
  <div>
    <el-form :model="formData" label-width="150px" :rules="rules">
      <el-row>
        <el-form-item label="物件番号：">
          {{ formData.wujian_id }}
        </el-form-item>
        <el-form-item label="楼层：">
          {{formData.floor}}
        </el-form-item>
      </el-row>

        <el-form-item label="先行楼层：" prop="star">
          <el-select v-model="formData.advance_floor" placeholder="先行楼层" style="width: 250px" clearable>
            <el-option v-for="dict in advanceFloorDataList" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
          </el-select>
        </el-form-item>

      <el-row>
        <el-form-item label-width="220px">
          <el-button type="success" @click="submit" :loading="loading">提交</el-button>
        </el-form-item>
      </el-row>
    </el-form>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'

export default {
  name: "MfgBatchNotFloorSplit",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        wujian_id: '',
        floor: '',
        advance_floor:'',
        ids:[]
      },
      advanceFloorDataList:[],
      rules: {
        star: [{required: true, message: '', trigger: 'red'}],
      },
    }
  },
  methods: {
    getAdvanceFloor(){
      this.$axios.post('mfg/floor/getAdvanceFloor', this.formData).then(response => {
        let res = response.data
        this.advanceFloorDataList = res.data
      })
    },
    getFloorBatch() {
      this.formData.wujian_id = this.parentData.wujian_id
      this.formData.floor = this.parentData.floor
      this.formData.ids = this.parentData.ids
      if (!this.formData.wujian_id) {
        return this.$message.error('请先选择物件番号搜索!')
      }
      if (!this.formData.floor || this.formData.floor.length <= 0) {
        return this.$message.error('请先选择楼层搜索!')
      }else {
        this.formData.floor = JSON.stringify(this.parentData.floor).replace(/\[|]/g, '').replace(/\"|"/g, '')
      }
      if (this.formData.ids.length <= 0) {
        return this.$message.error('请勾选需要拆分楼层的数据!')
      }
    },
    submit(){
      if (!this.formData.wujian_id) {
        return this.$message.error('请先选择物件番号搜索!')
      }
      if (!this.formData.floor || this.formData.floor.length <= 0) {
        return this.$message.error('请先选择楼层搜索!')
      }
      if (this.formData.ids.length <= 0) {
        return this.$message.error('请勾选需要拆分楼层的数据!')
      }

      if (!this.formData.advance_floor) {
        return this.$message.error(`先行楼层不能为空!`);
      }

      this.loading = true
      this.$axios.post('mfg/batch/notSplitFloor', this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.loading = false
          return this.$message.error(res.message);
        }
        this.loading = false
        this.setting.$fn.closeWindow();
        this.setting.$fn.reSearch();
        return this.$message.success('提交成功!');
      })
   },
  },created() {
    this.getFloorBatch()
    this.getAdvanceFloor()
  }
}
</script>


<style scoped>
.close {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 18px;
  cursor: pointer;
}

.row {
  /*border:1px solid black;*/
}

</style>